import './styles.scss';

import React, {useState} from 'react';

import {useAppSelector} from '../../../../../hooks';
import useLogout from '../../../../../hooks/useLogout';
import {useOutsideClick} from '../../../../../hooks/useOutsideClick';
import {selectUser} from '../../../../../slices/userSlice';
import {titleCase} from '../../../../../utils/FormatUtils';
import {getAvatar} from '../../../../../utils/UserUtils';

import {Link} from 'react-router-dom';

export enum AppHeaderMenuItemIcon {
    LOGOUT = 'header-user_logout',
    LITERACY = 'header-user_literacy',
    MY_PROFILE = 'header-user_my-profile',
}

export interface AppHeaderMenuItem {
    to: string;
    text: string;
    icon: AppHeaderMenuItemIcon;
}

interface AppHeaderUserProps {
    items?: AppHeaderMenuItem[];
}

export const HeaderUser = ({items = []}: AppHeaderUserProps) => {
    const user = useAppSelector(selectUser);
    const [showMenu, setShowMenu] = useState(false);
    const {logoutUser} = useLogout();
    const ref = useOutsideClick(() => {
        showMenu && setShowMenu(false);
    });

    return (
        <div className={`header-user${showMenu ? ' active' : ''}`}>
            <div className='header-user__head' onClick={() => setShowMenu(!showMenu)}>
                <img className='header-user__avatar' alt='User profile' src={getAvatar(user)} />
                {user.value?.first_name && (
                    <span className='header-user__name'>{titleCase(user.value?.first_name)}</span>
                )}
                {user.value && <span className='header-user__arrow'></span>} 
            </div>
            {showMenu && (
                <div ref={ref} className='header-user__container'>
                    {items?.map(({to, text, icon}) => (
                        <Link
                            key={text}
                            className={`header-user__item ${icon}`}
                            onClick={() => setShowMenu(false)}
                            to={to}>
                            {text}
                        </Link>
                    ))}
                    <span
                        className={`header-user__item ${AppHeaderMenuItemIcon.LOGOUT}`}
                        onClick={() => logoutUser()}>
                        Logout
                    </span>
                </div>
            )}
        </div>
    );
};
